const localStoragePrefix = 'storeeel_circleOverlayShown_';
const TTL_DAYS = 14;

export const circleOverlayShownRepository = {
  get(campaignId) {
    const key = `${localStoragePrefix}${campaignId}`;
    const item = localStorage.getItem(key);
    if (!item) return false;

    try {
      const parsed = JSON.parse(item);
      if (!parsed.expiresAt) return false;
      const now = new Date().getTime();
      if (now < parsed.expiresAt) {
        return true;
      } else {
        localStorage.removeItem(key);
        return false;
      }
    } catch {
      localStorage.removeItem(key);
      return false;
    }
  },
  set(campaignId) {
    const key = `${localStoragePrefix}${campaignId}`;
    const now = new Date().getTime();
    const expiresAt = now + TTL_DAYS * 24 * 60 * 60 * 1000;
    const value = JSON.stringify({ expiresAt });
    localStorage.setItem(key, value);
  }
};
